import { useAppEnvironmentContext } from 'contexts/appEnvironmentContext';
import { Flex } from 'ui/Layout';

import PageScrollableShadows from './PageScrollableShadows';

type Props = {
  children: React.ReactNode;
};

const Page: React.FC<Props> = ({ children }) => {
  const { appEnvironment } = useAppEnvironmentContext();
  return (
    <Flex alignItems="stretch" direction="column" w="100vw" h="100vh">
      {appEnvironment === 'office' && <PageScrollableShadows />}
      {children}
    </Flex>
  );
};

export default Page;
